<template>
  <div>
    <AppView
      v-if="!appLoading && routeSet"
      id="statzon"
    />

    <div :class="['app__loading', !appLoading && routeSet ? 'app__loading--hidden' : '']">
      <div class="app__loading__logo" />
      <div class="app__loading__animation">
        <div class="app__loading__animation--a"></div>
        <div class="app__loading__animation--b"></div>
        <div class="app__loading__animation--c"></div>
        <div class="app__loading__animation--d"></div>
        <div class="app__loading__animation--e"></div>
        <div class="app__loading__animation--f"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppView from '@/components/app/View.vue'

export default {
  components: {
    AppView
  },
  computed: {
    appLoading () {
      return this.$store.getters['app/getAppLoading']
    },
    routeSet () {
      if (this.$route.name && this.$route.name.length > 0) {
        return true
      }
      return false
    },
  },
  beforeCreate: async function () {
    /*if (window.innerWidth > 640) {
      this.$store.commit('app/setInitOpen', true)
    }*/
    await this.$store.dispatch('app/initialize')
    this.$store.commit('app/setAppLoading', false)

    // Google Structured Data objects
    let organizationObject = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "sameAs": [
        "https://www.instagram.com/statzon/",
        //"https://facebook.com/x",
        "https://twitter.com/Statzon1",
        "https://linkedin.com/company/statzon"
      ],
      "name": "Statzon",
      "url": "https://statzon.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://app.statzon.com/img/statzon_z_black.png",
        "width": "150",
        "height": "150"
      },
      "email": "info@statzon.com",
      "telephone": "+358 504 713 021",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+358 504 713 021",
        "availableLanguage": [
          "English",
          "Finnish"
        ],
        "contactType": "sales",
        "email": "sales@statzon.com"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Aleksanterinkatu 11 A3",
        "addressLocality": "Lahti",
        "addressRegion": "Päijät-Häme",
        "postalCode": "15110",
        "addressCountry": "Finland"
      },
      "description": "Statzon is a subscription-based market intelligence platform providing access to in-depth market reports and insights from hundreds of trusted sources.",
      "founder": [
        {
          "@type": "Person",
          "givenName": "Kimmo",
          "familyName": "Kuokkanen",
          "jobTitle": "Chief Executive Officer"
        },
        {
          "@type": "Person",
          "givenName": "Tomi",
          "familyName": "Karila",
          "jobTitle": "Chief Technology Officer"
        }
      ]
    }

    let scriptTag = document.createElement('script')
    scriptTag.type = 'application/ld+json'
    scriptTag.textContent = JSON.stringify(organizationObject)
    document.head.appendChild(scriptTag)
  },
}
</script>

<style lang="scss">
@import '@/styles/app.scss';
@import '@/styles/normalize.scss';
@import '@/styles/base.scss';
@import '@/styles/animations.scss';

#statzon {
  position: relative;
  z-index: 666;
  overflow: hidden;
  min-height: 100vh;
  height: auto;
}

.app__loading {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: $bg-1;
  opacity: 1;
  transition: opacity 0.4s ease-in;

  &--hidden {
    opacity: 0;
    z-index: -1;
  }

  &__logo {
    position: relative;
    top: calc(50% - 14px - 70px);
    background-image: url("/img/statzon_logo_white.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 28px;
    width: auto;
    animation: blink 5s 1 ease-in;
  }

  &__animation {
    margin: 0 auto;
    width: 60px;
    height: 50px;
    text-align: center;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 30px);

    div {
      height: 100%;
      width: 8px;
      border-radius: 8px;
      display: inline-block;
      margin-left: 2px;
      animation: delay 1.2s infinite ease-in-out;
    }

    &--a {
      background-color: $blue;//#754fa0;
    }

    &--b {
      background-color: $green;// #09b7bf;
      animation-delay: -1.1s !important;
    }

    &--c {
      background-color: $yellow;//#90d36b;
      animation-delay: -1.0s !important;
    }

    &--d {
      background-color: $orange;// #f2d40d;
      animation-delay: -0.9s !important;
    }

    &--e {
      background-color: $pink;// #fcb12b;
      animation-delay: -0.8s !important;
    }

    &--f {
      background-color: $purple;// #ed1b72;
      animation-delay: -0.7s !important;
    }
  }
}

@keyframes delay {
  0%, 40%, 100% {
    transform: scaleY(0.05);
  } 20% {
    transform: scaleY(1.0);
  }
}
</style>
